import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useMessagesListSort = () => {
  const { t } = useTranslation('scout');

  return useMemo(
    () => [
      {
        label: t('messageNumber'),
        value: 'count',
      },
      {
        label: t('lastUpdated'),
        value: 'updatedOn',
      },
      {
        label: t('createdDate'),
        value: 'createdOn',
      },
      {
        label: t('name'),
        value: 'createdBy',
      },
      {
        label: t('status'),
        value: 'hidden',
      },
    ],
    [t],
  );
};

export default useMessagesListSort;
